import { render, staticRenderFns } from "./CreateBasicInfoPlusInfo.vue?vue&type=template&id=e5137f72&"
import script from "./CreateBasicInfoPlusInfo.vue?vue&type=script&lang=ts&"
export * from "./CreateBasicInfoPlusInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports